import {
  Hussle_Logo,
  shop_brand,
  tranont_brand,
} from '../../assets/icons';
import useAppNavigation from '../../hooks/useAppNavigation';
import useAppAccessor from '../../hooks/useappAccessor';
import { getBrandColor } from '../../utils/brand.util';

const LiveEnd = () => {
  const { navigate } = useAppNavigation();
  const { getLiveMainData, getUserData } = useAppAccessor();
  const { joinData } = getLiveMainData();
  const { client, language } = getUserData();

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

  const getLogo = () => {
    switch (client) {
      case 'Tranont': {
        return tranont_brand;
      }
      case 'Market America': {
        return shop_brand;
      }
      default: {
        return null;
      }
    }
  };

  const brandColor = getBrandColor(client);

  return (
    <div
      className="flex h-screen w-full items-center justify-center"
      style={{
        background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%)",
      }}
    >
      <div className="flex flex-col items-center w-full px-4 py-8 max-w-2xl">
        <div
          className="flex flex-col items-center w-full rounded-3xl overflow-hidden relative"
          style={{
            background: "linear-gradient(145deg, #2d2d2d 0%, #1a1a1a 100%)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5), 0 4px 16px rgba(0, 0, 0, 0.3)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            maxWidth: isMobile ? "100%" : "520px",
          }}
        >
          <div 
            className="absolute top-0 left-0 right-0 h-1 rounded-t-3xl"
            style={{ backgroundColor: brandColor }}
          />
          
          <div className="flex flex-col items-center px-8 py-10 w-full">
            {getLogo() && (
              <img
                src={getLogo() || ''}
                width={isMobile ? 100 : 150}
                className='mb-6'
                alt="Brand Logo"
              />
            )}
            
            <h2 className="text-white text-2xl font-semibold mb-4 text-center tracking-tight">
              {joinData?.role === 'attendee'
                ? language['host_ended_live']
                : language['left_livestream']}
            </h2>
            
            {joinData?.role !== 'attendee' && (
              <button
                className="px-8 py-3 rounded-xl text-white font-semibold transition-all duration-200 active:scale-95 shadow-lg mt-4"
                onClick={() => {
                  navigate({ screen: '/' });
                  setTimeout(() => {
                    window.location.reload();
                  }, 100);
                }}
                style={{ 
                  backgroundColor: brandColor,
                  boxShadow: `0 4px 12px ${brandColor}40`
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = "0.9";
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = `0 6px 16px ${brandColor}60`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = "1";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = `0 4px 12px ${brandColor}40`;
                }}
              >
                {language['rejoin_button']}
              </button>
            )}
          </div>
        </div>

        <div className="mt-8">
          <div className="flex items-center justify-center">
            <span className="text-gray-400 text-xs mr-2">Powered by</span>
            <img src={Hussle_Logo} width={65} alt="Hussle Logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveEnd;
